export const FETCH_COURSE_TYPE = {
  START: 'START_FETCH_COURSE_TYPE',
  COMPLETE: 'COMPLETE_FETCH_COURSE_TYPE',
  FAIL: 'FAIL_FETCH_COURSE_TYPE',
  CLEANUP: 'CLEANUP_FETCH_COURSE_TYPE',
}

export const UPDATE_COURSE_TYPE_DETAILS = {
  START: 'START_UPDATE_COURSE_TYPE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_COURSE_TYPE_DETAILS',
  FAIL: 'FAIL_UPDATE_COURSE_TYPE_DETAILS',
}

export const UPDATE_COURSE_TYPE_IMAGE_DETAILS = {
  START: 'START_UPDATE_COURSE_TYPE_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_COURSE_TYPE_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_COURSE_TYPE_IMAGE_DETAILS',
}
